// Cross-view cache for the Deal Flow header tabs (pipelines + statuses).
//
// Why this exists: FetchPipelines and FetchPipelinesStatuses are useMutation, and
// React Query does not cache mutations - only useQuery results live in the cache.
// DealFlowShell also unmounts one view when you switch to the other, so the tabs
// were held only in the unmounted component's state. Every toggle therefore threw
// the data away and re-fetched it, and the tab strip visibly disappeared and came
// back - "the status seems reloading" even though it was already fetched.
//
// Seeding each view's state from here makes the tabs paint immediately on switch;
// the background re-fetch still runs and overwrites with fresh data.
//
// Both views must use the SAME keys or the cache does nothing across a switch.
// The stored value is the already-mapped array both views build (value/_id,
// label, mappedValue, display_order), which is identical in each - only the
// wrapper differs (the list keeps { data: [...] }, the board a flat array).
//
// Same localStorage approach KanbanBoard already uses for its column layout.

const cacheKey = (investorId, kind) => `df_tabs:${kind}:${investorId}`;

export const readTabsCache = (investorId, kind) => {
  if (!investorId) return null;
  try {
    const raw = localStorage.getItem(cacheKey(investorId, kind));
    const parsed = raw ? JSON.parse(raw) : null;
    return Array.isArray(parsed) && parsed.length > 0 ? parsed : null;
  } catch (e) {
    return null;
  }
};

export const writeTabsCache = (investorId, kind, items) => {
  if (!investorId || !Array.isArray(items)) return;
  try {
    localStorage.setItem(cacheKey(investorId, kind), JSON.stringify(items));
  } catch (e) {
    /* ignore quota / private-mode errors */
  }
};
